import {
    SET_LOADING,
    CLEAR_BRANCH,
    GET_SINGLE_BRANCH,
    GET_BRANCHES,
    BRANCH_INPUT_CHANGE,
    SEARCH_INPUT,
    SET_PAGE,
    BRANCH_SELECT_COUNTRY,
    BRANCH_HANDLE_MOBILE,
    BRANCH_ADD_FILE,
    BRANCH_REMOVE_FILE,
    BRANCH_UPDATE_FILE,
    SET_MINI_LOADING,
    BRANCH_HISTORY_DATE_INPUT_CLEAR,
    DATE_FILTER_INPUT,
    SET_DYNAMIC_LOADING,
    BRANCH_UPLOADS_TO_REMOVE,
    SORT_BY_COLUMN,
    GET_ROWS_TO_DELETE,
    SET_ROW_CHECKED,
    BRANCH_GET_UPLOADED_FILES,
    BRANCH_CLEAR_UPLOAD,
    BRANCH_SET_USER_OPTIONS,
    BRANCH_AUTO_FILL,
} from '../types';

// state
const initialState = {
    pagination: {
        totalCount: 0,
        activePage: 1,
        itemsCountPerPage: 1,
        totalItemsCount: 10,
        pageRangeDisplayed: 8,
    },
    branches: [],
    single_branch: {
        name: '',
        business_name: '',
        street1: '',
        street2: '',
        city: '',
        state: '',
        country: {},
        fax: '',
        email: '',
        landline: '',
        mobile: '',
        contact_person: '',
        uploads: [],
        tin: '',
    },
    new_uploads: [],
    files_to_remove: [],
    search: '',
    date_from: new Date(),
    date_to: new Date(),
    date_filter: false,
    loading: false,
    isSearchable: true,
    mini_loading: false,
    main_page: false,
    edit_page: false,
    print_modal: false,
    main_url: '/inventory/branches',
    create_url: '/inventory/branches/create',
    edit_url: '/inventory/branches/edit',
    history_url: '/inventory/branches/history',
    rows_to_delete: null,
    sort_order_name: null,
    sort_order_direction: null,
    set_row_checked: false,
    upload_loading: false,
    user_options: [],
    selected_user: null,
};

const branchReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_BRANCHES:
            return {
                ...state,
                branches: action.payload.branches,
                pagination: action.payload.pagination,
                set_row_checked: false,
            };
        case GET_SINGLE_BRANCH:
            return {
                ...state,
                single_branch: action.payload,
            };
        case BRANCH_INPUT_CHANGE:
            return {
                ...state,
                single_branch: {
                    ...state.single_branch,
                    [action.payload.key]: action.payload.value,
                },
            };
        case BRANCH_SELECT_COUNTRY:
            return {
                ...state,
                single_branch: {
                    ...state.single_branch,
                    country: action.payload,
                },
            };
        case BRANCH_HANDLE_MOBILE:
            return {
                ...state,
                single_branch: {
                    ...state.single_branch,
                    mobile: action.payload,
                },
            };
        case SEARCH_INPUT:
            return {
                ...state,
                search: action.payload,
            };
        case SET_LOADING:
            return {
                ...state,
                loading: action.payload,
            };
        case SET_MINI_LOADING:
            return {
                ...state,
                mini_loading: action.payload,
            };
        case SET_PAGE:
            if (action.payload.page == 'main_page') {
                return {
                    ...state,
                    edit_page: false,
                    [action.payload.page]: action.payload.status,
                };
            } else if (action.payload.page == 'edit_page') {
                return {
                    ...state,
                    main_page: false,
                    edit_url: action.payload.edit_url,
                    [action.payload.page]: action.payload.status,
                };
            } else if (action.payload.page == 'history_page') {
                return {
                    ...state,
                    main_page: false,
                    history_url: action.payload.history_url,
                    [action.payload.page]: action.payload.status,
                };
            } else {
                return {
                    ...state,
                    [action.payload.page]: action.payload.status,
                };
            }
        case BRANCH_ADD_FILE:
            return {
                ...state,
                single_branch: {
                    ...state.single_branch,
                    uploads: [
                        ...state.single_branch.uploads,
                        ...action.payload,
                    ],
                },
            };
        case BRANCH_UPDATE_FILE:
            return {
                ...state,
                new_uploads: [...state.new_uploads, ...action.payload],
            };
        case BRANCH_REMOVE_FILE:
            if (action.payload.status == 'old') {
                return {
                    ...state,
                    single_branch: {
                        ...state.single_branch,
                        uploads: [
                            ...state.single_branch.uploads.filter(
                                (file) => file.name !== action.payload.name
                            ),
                        ],
                    },
                };
            } else {
                return {
                    ...state,
                    new_uploads: [
                        ...state.new_uploads.filter(
                            (file) => file.name !== action.payload.name
                        ),
                    ],
                };
            }
        case BRANCH_UPLOADS_TO_REMOVE:
            return {
                ...state,
                files_to_remove: [...state.files_to_remove, action.payload],
            };
        case BRANCH_CLEAR_UPLOAD:
            return {
                ...state,
                new_uploads: [],
            };
        case CLEAR_BRANCH:
            return {
                ...state,
                single_branch: { uploads: [] },
                new_uploads: [],
                files_to_remove: [],
                date_from: new Date(),
                date_to: new Date(),
                date_filter: false,
                loading: false,
                mini_loading: false,
                main_page: false,
                edit_page: false,
                print_modal: false,
                main_url: '/inventory/branches',
                create_url: '/inventory/branches/create',
                edit_url: '/inventory/branches/edit',
                history_url: '/inventory/branches/history',
                rows_to_delete: null,
            };
        case DATE_FILTER_INPUT:
            return {
                ...state,
                [action.payload.key]: action.payload.value,
            };
        case BRANCH_HISTORY_DATE_INPUT_CLEAR:
            return {
                ...state,
                date_from: new Date(),
                date_to: new Date(),
                date_filter: false,
            };
        case SORT_BY_COLUMN:
            return {
                ...state,
                sort_order_name: action.payload.sort_order_name,
                sort_order_direction: action.payload.sort_order_direction,
            };
        case GET_ROWS_TO_DELETE:
            return {
                ...state,
                rows_to_delete: action.payload,
            };
        case SET_ROW_CHECKED:
            return {
                ...state,
                set_row_checked: true,
            };
        case BRANCH_GET_UPLOADED_FILES:
            return {
                ...state,
                single_branch: {
                    ...state.single_branch,
                    uploads: action.payload,
                },
                new_uploads: [],
                files_to_remove: [],
            };
        case SET_DYNAMIC_LOADING:
            return {
                ...state,
                [action.payload.key]: action.payload.status,
            };
        case BRANCH_SET_USER_OPTIONS:
            return {
                ...state,
                user_options: action.payload,
            };
        case BRANCH_AUTO_FILL:
            return {
                ...state,
                single_branch: {
                    ...state.single_branch,
                    ...action.payload,
                },
                selected_user: action.payload,
            };
        default:
            return state;
    }
};

export default branchReducer;
